import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAVnElkREYv1V5HBckGZjoqHjP9KEGZVFg",
  authDomain: "safesnap-aa25e.firebaseapp.com",
  projectId: "safesnap-aa25e",
  storageBucket: "safesnap-aa25e.firebasestorage.app",
  messagingSenderId: "348084820334",
  appId: "1:348084820334:web:204ce6a2a032769ec1097f"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
